var e="data:image/svg+xml,%3csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M10 3L4.5 8.5L2 6' stroke='%23E9630C' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";export{e as default};
//# sourceMappingURL=checkv2.svg.js.map
